import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';

export interface ConfirmDialogPayload {
  title: string;
  message?: string; 
  comment?: string; 
  commentRequired?: boolean;
}

export interface ConfirmDialogResponse {
  isConfirmed: boolean;
  comment?: string; 
}

@Component({
  selector: 'app-confirm-dialog',
  imports: [
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
  ],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  private _data = inject<ConfirmDialogPayload>(MAT_DIALOG_DATA);
  private _dialogRef: MatDialogRef<ConfirmDialogComponent, ConfirmDialogResponse> = inject(MatDialogRef);

  title: string | null = 'Confirm';
  message?: string;
  comment?: string; 
  commentRequired: boolean = false;

  constructor() {
    this.title = this._data.title;
    this.message = this._data.message;
    this.comment = this._data.comment;
    this.commentRequired = this._data.commentRequired ?? false;
  }

  confirm(): void {
    this._dialogRef.close({ isConfirmed: true, comment: this.comment });
  }

  isConfirmDisabled(): boolean {
    return this.commentRequired && (!this.comment || this.comment.trim().length === 0);
  }
}
